import {connect} from 'react-redux';
import {
  peopleSelector,
} from '../../../reducers';
import AgendaDay from './component';

const mapStateToProps = (state) => {
  return {
    allPeople: peopleSelector(state) || {},
  };
};

export default connect(mapStateToProps)(AgendaDay);



// WEBPACK FOOTER //
// ./src/component/organisms/AgendaDay/index.js